import DocumentPatterns from "./DocumentPatterns";

export default DocumentPatterns;
